//页面级 TDK 设置：路由切换与详情页异步取数后都会用到。
//独立成模块，避免 router 与组件各写一套 meta 操作。

export const defaultSeo = {
  title: '金蓝盟-企业管理咨询|企业培训|管理咨询公司',
  description: '金蓝盟（www.jinlanmeng.cn）是专业的企业管理咨询公司，提供企业管理咨询、企业培训、IT咨询、上市助推等一站式服务，助力企业提升管理水平与经营业绩。',
  keywords: '金蓝盟,企业管理咨询,企业培训,管理咨询公司,企业内训,上市咨询'
}

//按 name 查找 meta 标签，不存在则创建
export function setMetaTag(name, content) {
  let tag = document.querySelector('meta[name="' + name + '"]')
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content || '')
}

//注入路由级 JSON-LD 结构化数据（如 FAQPage），切换路由时先清理上一次注入的
export function setStructuredData(data) {
  const old = document.querySelector('script[data-seo-jsonld]')
  if (old) old.parentNode.removeChild(old)
  if (!data) return
  const script = document.createElement('script')
  script.type = 'application/ld+json'
  script.setAttribute('data-seo-jsonld', 'true')
  script.textContent = JSON.stringify(data)
  document.head.appendChild(script)
}

function setRobots(noindex) {
  const tag = document.querySelector('meta[name="robots"]')
  if (!noindex) {
    if (tag) tag.parentNode.removeChild(tag)
    return
  }
  setMetaTag('robots', 'noindex,follow')
}

//统一入口：只传需要覆盖的字段，未传的保持当前值
export function setSeo(opts) {
  const o = opts || {}
  if (o.title) document.title = o.title
  if (o.description !== undefined) setMetaTag('description', o.description)
  if (o.keywords !== undefined) setMetaTag('keywords', o.keywords)
  if (o.noindex !== undefined) setRobots(o.noindex)
}

//从正文 HTML 中提取纯文本摘要
export function plainExcerpt(html, maxLength) {
  const text = String(html || '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  const max = maxLength || 80
  return text.length > max ? text.slice(0, max) + '…' : text
}



// WEBPACK FOOTER //
// ./src/utils/seo.js